import { Plugin, PluginKey } from "prosemirror-state";

export const addressingKey = new PluginKey<string>("addressing");

/**
 * Plugin that tracks the current cursor position and
 * exposes the current statement's SID.
 */
export function addressingPlugin(): Plugin {
  return new Plugin({
    key: addressingKey,

    state: {
      init(): string {
        return "";
      },
      apply(tr, value, _oldState, newState): string {
        const { $from } = newState.selection;

        // Walk up to find the statement node
        for (let depth = $from.depth; depth >= 0; depth--) {
          const node = $from.node(depth);
          if (node.type.name === "statement") {
            return node.attrs.sid as string;
          }
        }

        return value;
      },
    },
  });
}

/**
 * Get the current SID from an editor state.
 */
export function getCurrentSID(
  state: import("prosemirror-state").EditorState
): string {
  return addressingKey.getState(state) ?? "";
}
